module.exports = __webpack_public_path__ + "img/glasshive-icon-stroke.d8af7d54.png";